import { useState } from 'react';
import close from "../../assets/images/close.png";
import {
  Modal,
  ModalBody,
} from 'reactstrap';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axiosInstance from '../../helpers/axios';

export default function GetAllPartners() {
   
    const [formOpen, setFormOpen] = useState(false);
    
    const user = null

    const [partners,setPartners] = useState([])
    const popUpForm = () => {
        setFormOpen(true);
        axiosInstance.get(`/channel-partners/get-partners`)
        .then((res)=>{
        setPartners(res?.data?.data)
        }).catch((err) => err)
    }

  return (
    <div>
     <p style={{fontFamily:'Inter-Medium',fontSize:'16px',fontWeight:'500', textTransform: 'capitalize',cursor:'pointer',width:'120px',height:'34px',fontFamily:'Inter-Medium',fontSize:'16px',backgroundColor:'#D22129',display:'flex',alignItems:'center',justifyContent:'center',color:'white',borderRadius:'6px'}} onClick={() => popUpForm()}>All Partners</p>
    
      {formOpen && (
      <>
     <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 999,
        }}
      ></div>
      <Modal style={{ top: '5%', backgroundColor: 'white',maxWidth: '70%',}} size="lg" className='edit-form ' isOpen={formOpen}>
          
          <div style={{borderTopLeftRadius:'10px',borderTopRightRadius:"10px",display:"flex",flexDirection:'row',padding:"20px",justifyContent:"space-between",backgroundColor:"#E9E9E9",height:"50px",alignItems:"center"}}><p className='heading'>All Partners</p>
          <img style={{height:'1.5em',width:'1.5em'}} className="image1" onClick={()=>setFormOpen(!formOpen)} src={close}/>
          </div>
        
        <ModalBody>
        <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{fontWeight:'bold'}}>Partner Name</TableCell>
            <TableCell sx={{fontWeight:'bold'}}>Mobile</TableCell>
            <TableCell sx={{fontWeight:'bold'}}>Email</TableCell>
            <TableCell sx={{fontWeight:'bold'}}>PAN</TableCell>
            <TableCell sx={{fontWeight:'bold'}}>Bank Acc. Number</TableCell>
            <TableCell sx={{fontWeight:'bold'}}>Ifsc</TableCell>
            <TableCell sx={{fontWeight:'bold'}}>Beneficiary Name</TableCell>
            <TableCell sx={{fontWeight:'bold'}}>Partner Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {partners.map((row) => (
            <TableRow
              key={partners.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell>
                {row.name}
              </TableCell>
              <TableCell >{row.phone}</TableCell>
              <TableCell >{row.email}</TableCell>
              <TableCell >{row.pan}</TableCell>
              <TableCell >{row.bankAccountNumber}</TableCell>
              <TableCell >{row.ifsc}</TableCell>
              <TableCell >{row.beneficiaryName}</TableCell>
              <TableCell >{row.partnerType}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
        </ModalBody>
       
        
      </Modal>
      </>
       )}
    </div>
  );
}


